import React from 'react';
import { Spinner } from '@treelab/panda';

import { LoadingContainer } from './styled';

const Raw: React.FC = () => (
  <LoadingContainer>
    <Spinner itemSize="small" />
  </LoadingContainer>
);

export default Raw;
